import { Counter } from '@modulor/react';
import type { CSSProperties } from 'react';
import { useBonusesPictogram } from '../../../BonusesPictogram/hooks';

const BonusesNotification = () => {
  const isShownPictogram = useBonusesPictogram();

  return isShownPictogram ? (
    <Counter
      value={0}
      style={
        {
          '--counter-background': 'var(--icon-notification)',
        } as CSSProperties
      }
    />
  ) : null;
};
export default BonusesNotification;
